import { FieldType } from "@certa/types/src/studio";

export const INTEGRATION_FIELDS = "integrationFields";

export enum OptionSource {
  DEFAULT = "default",
  PREDEFINED = "predefined-options",
  CUSTOM_ENDPOINT = "custom-endpoint"
}

export const DEFAULT_OPTIONS_SOURCE = OptionSource.DEFAULT;

export const fieldTypesWithOptionsSource: FieldType[] = [
  FieldType.DROPDOWN_MULTI,
  FieldType.DROPDOWN_SINGLE,
  FieldType.CASCADER,
  FieldType.CHECKBOX,
  FieldType.RADIO,
  FieldType.GROUPED_CHECKBOX
];

export const sizeRegex = /^\d+(px|%)$/;
